import { Script } from 'gatsby';
import React from "react";

export function QuizSection({ section }) {

  const quizScript = `
    (function(i, s, o, g, r, a, m) {
      var ql = document.querySelectorAll(
        "A[quiz],DIV[quiz],A[data-quiz],DIV[data-quiz]"
      );
      if (ql) {
        if (ql.length) {
          for (var k = 0; k < ql.length; k++) {
            ql[k].id = "quiz-embed-" + k;
            ql[k].href =
              "javascript:var i=document.getElementById('quiz-embed-" +
              k +
              "');try{qz.startQuiz(i)}catch(e){i.start = 1;i.style.cursor='wait';i.style.opacity='0.5'};void(0);";
          }
        }
      }
      i["QP"] = r;
      (i[r] =
        i[r] ||
        function() {
          (i[r].q = i[r].q || []).push(arguments);
        }),
        (i[r].l = 1 * new Date());
      (a = s.createElement(o)), (m = s.getElementsByTagName(o)[0]);
      a.async = 1;
      a.src = g;
      m.parentNode.insertBefore(a, m);
    })(
      window,
      document,
      "script",
      "https://take.quiz-maker.com/3012/CDN/quiz-embed-v1.js",
      "qp"
    );
  `;

  return (
    <>
      <section className="container-fluid eva-text-center container-blocks" style={{ backgroundColor: section.body?.backgroundColor, color: section.body?.textColor }}>
        <div className="container">
          <a
            data-quiz={section.body?.quizCode}
            data-type="4"
            href={`https://take.quiz-maker.com/${section.body?.quizCode}`}
          >
          </a>
          <Script dangerouslySetInnerHTML={{ __html: quizScript }}></Script>
        </div >
      </section >
    </>
  )
}